module.exports = __webpack_public_path__ + "img/ci-pooq-id.02acbb4b.png";